"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchVehicleUserDeviceToken = void 0;
/**
 * Update a driver's device token. (The token is required to send push notifications.)
 */
var patchVehicleUserDeviceToken = function (instance) {
    return function (email, body, config) {
        return instance.patch("/vehicles/users/".concat(email, "/device-token"), body, config);
    };
};
exports.patchVehicleUserDeviceToken = patchVehicleUserDeviceToken;
